module.exports = __webpack_public_path__ + "img/empty.931f2e19.png";